export enum EnumAcaoRecurso {
    Inserir = 'Inserir',
    Consultar = 'Consultar',
    Editar = 'Editar',
    Visualizar = 'Visualizar',
    AtivarInativar = 'Ativar-Inativar',
    Excluir = 'Excluir',
    Imprimir = 'Imprimir',
    EnviarParaAprovacao = 'Enviar para Aprovação',
    Planejar = 'Planejar',
    Elaborar = 'Elaborar',
    GerarNovaVersao = 'Gerar Nova Versão',
    RegistrarVersao = 'Registrar Versão',
    Relatoria = 'Relatoria',
    Avaliar = 'Avaliar',
    Detalhar = 'Detalhar',
    Exportar = 'Exportar',
    GerarPAA = 'Gerar PAA',
    Importar = 'Importar',
    Responder = 'Responder',
    Novo = 'Novo',
    CadastrarPlanejamento = 'Cadastrar planejamento',
    Criar = 'Criar',
    InserirDados = 'Inserir Dados',
    IrParaModelos = 'Ir Para Modelos',
    AprovarDevolver = 'Aprovar / Devolver',
    PublicarModelo = 'Publicar Modelo',
    ExportarArquivos = 'Exportar Arquivos',
    historico = 'Histórico',
    Delegar = 'Delegar',
    Executar = 'Executar',
    IrParaProcessos = 'Ir Para Processos',
    UsarModelo = 'Usar Modelo',
    Responsaveis = 'Responsáveis',
    Versoes = 'Versões',
    Arquivar = 'Arquivar',
    RegistrarPausa = 'Registrar Pausa',
    Inativar = 'Inativar',
    Preencher = 'Preencher',
    AprovarMatrizPreliminar = 'Aprovar - Matriz de Constatação',
    Monitorar = 'Monitorar',
    Finalizar = 'Finalizar',
    Reabrir = 'Reabrir',
    Cancelar = 'Cancelar',
    Historico = 'Histórico',
    PrescricaoFatoCadastrar = 'Prescrição do Fato - Cadastrar',
    PrescricaoFatoEnviarAnalise = 'Prescrição do Fato - Enviar para Analise',
    PrescricaoFatoVisualizar = 'Prescrição do Fato - Visualizar',
    PrescricaoParCadastrar = 'Prescrição PAR - Cadastrar',
    PrescricaoParEnviarCpar = 'Prescrição PAR - Enviar CPAR',
    PrescricaoParVisualizar = 'Prescrição PAR - Visualizar',
    IncluirDestaques = 'Incluir Destaques',
    IncluirTipoDeTrabalho = 'Incluir Tipo de Trabalho',
    IncluirDispensas = 'Incluir Dispensas',
    Publicar = 'Publicar',
    GerarPDF = 'Gerar PDF',
    CadastrarCapitulo = 'Cadastrar Capítulo',
    CadastrarSubCapitulo = 'Cadastrar subcapítulo',
    ComparativoAlteracoes = 'Comparativo de alterações',
    ArquivosCadastrar = 'Arquivos - Cadastrar',
    ArquivosVisualizar = 'Arquivos - Visualizar',
    ArquivosExcluir = 'Arquivos - Excluir',
    ArquivosEnviarAnalise = 'Arquivos - Enviar para Analise',
    ArquivosVincularDocumento = 'Arquivos - Vincular Documento',

    FichamentoCadastrar = 'Fichamento - Cadastrar',
    FichamentoVisualizar = 'Fichamento - Visualizar',
    FichamentoExcluir = 'Fichamento - Excluir',
    FichamentoIncluirEmpresasEnvolvidas = 'Fichamento - Incluir Empresas Envolvidas',

    AnaliseInicialCadastrar = 'Analise Inicial - Cadastrar',
    AnaliseInicialVisualizar = 'Analise Inicial - Visualizar',
    AnaliseInicialIncluirEnquadramento = 'Analise Inicial - Incluir Enquadramento',

    FinalizarMonitoramento = 'Finalizar Monitoramento',
    Duplicar = 'Duplicar',
    CadastrarTabela = 'Cadastrar Tabela',
    AdicionarFaixa = 'Adicionar faixa',

    Sincronizar = 'Sincronizar',
    Habilitar = 'Habilitar',

    AvocarProcesso = 'Avocar Processo',
    DistribuirProcesso = 'Distribuir Processo',
    Anotacao = 'Anotações',
    Aprovar = 'Aprovar',
    Devolver = 'Devolver',
    VisualizarPreview = 'Visualizar preview',
    Submeter = 'Submeter',
    
    ArquivosAssociar = 'Arquivos - Associar',
    ProcessoExcluir = 'Processo - Excluir',
    ProcessoAdicionarDocumento = 'Processo - Adicionar Documento',
    ProcessoJuntar = 'Processo - Juntar',
    ProcessoEspelhamento = 'Processo - Espelhamento',
    UploadRelatoria = 'Upload de relatoria',
    enviarParaMonitoramento = 'Enviar para Monitoramento',
}
